import { efficiencyFlagListMessages } from '../messages';
import type { TireEfficiencyTypes } from '../types';

export function getEfficiencyFlagListMessage(type: TireEfficiencyTypes) {
  if (type in efficiencyFlagListMessages) {
    return efficiencyFlagListMessages[type];
  }
  return null;
}
